import React from "react";
import ReactModal from "react-modal";
import styles from "./OnboardingModal.module.scss";
import CloseButton from "../CloseButton";
/**
 * Reusable OnboardingModal component that wraps ReactModal
 * with default styling (countryModal and modalOverlay classes).
 * All ReactModal props can be passed through and will override defaults.
 *
 * @param {Object} props - All ReactModal props are accepted
 * @param {string} props.className - Additional class names to merge with countryModal
 * @param {string} props.overlayClassName - Additional class names to merge with modalOverlay
 * @param {boolean} props.shouldCloseOnEsc - Default: true
 * @param {boolean} props.shouldCloseOnOverlayClick - Default: true
 */
const OnboardingModal = ({
  className = "",
  overlayClassName = "",
  shouldCloseOnEsc = true,
  shouldCloseOnOverlayClick = true,
  onRequestClose,
  children,
  ...restProps
}) => {
  // Merge default classes with custom ones
  const mergedClassName = `${styles.countryModal} ${className}`.trim();
  const mergedOverlayClassName = `${styles.modalOverlay} ${overlayClassName}`.trim();

  return (
    <ReactModal
      shouldCloseOnEsc={shouldCloseOnEsc}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      className={mergedClassName}
      overlayClassName={mergedOverlayClassName}
      {...restProps}
    >
      <CloseButton
        onClick={onRequestClose}
      />
      {children}
    </ReactModal>
  );
};

export default OnboardingModal;

